module.exports = __webpack_public_path__ + "img/damDeflatedDanger.9d38b939.svg";